module.exports = __webpack_public_path__ + "img/icon_win.bcaf2268.png";